module.exports = "<section class=feed__blog><div class=feed__blog-content><div class=\"row d-flex flex-wrap\"><div class=col-md-4 ng-repeat=\"item in $ctrl.postByCategory\"><div class=feed__blog-item><div class=feed__blog-image><img class=img-responsive ui-sref=\"home.blogDetail({blogSlug : item.slug})\" src=\"{{ item.imagen }}\"></div><h4 class=\"feed__blog-title small\">{{ item.nombre }}</h4><p class=feed__blog-text>{{ item.descripcion }}</p><a class=feed__blog-link ui-sref=\"home.blogDetail({blogSlug : item.slug})\">ver más</a></div></div></div></div></section>";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/catalog/category/box-post-by-category/templates/box-post-base-view.html
 ** module id = 615
 ** module chunks = 7
 **/